module.exports = __webpack_public_path__ + "img/Logo_Basic.f6a871e4.png";